import React from 'react'
import { connect } from 'react-redux'
import { addLayer, removeLayer } from '../actions'
import $ from "jquery";

let ToggleLegend = ({ layerId, item, children, dispatch }) => {
  if (children) {
    return (
      <div className="tertiary-menu">
      <ul className="tertiary">
        { children.map((child, i) =>
         <li key={i}><a href="#layer"
            id={ child.id }
            data-group={ child.group }
            data-exclusive={ child.exclusive }
            data-labels={ child.labels }
         onClick={e => {
           e.preventDefault()


             if ($(e.currentTarget).hasClass('layer-on')) {
               $(e.currentTarget).removeClass('layer-on')
               dispatch(removeLayer(child.id))
               //dispatch(removeLayer(child.borders))
               //dispatch(removeLayer(child.labels))

             } else {
               $(e.currentTarget).addClass('layer-on')
               $(e.target).parents('.secondary li').find('a.layer').addClass('layer-on')
               dispatch(addLayer(child.id, child.group))
               if (child.labels || child.borders) {
                dispatch(addLayer(child.labels, child.group))
               }
             }

             if (child.exclusive === true ) {
               var layers = $('.tertiary-menu [data-group="' + child.group + '"]')
               $.each(layers, function(i, l) {
                 var lid = $(l).attr('id');
                 var labelsLayer = $(l).data('labels');
                 if (lid !== child.id) {
                   if ($(l).hasClass('layer-on')) {
                    $(l).removeClass('layer-on')
                     dispatch(removeLayer(lid))
                     if (labelsLayer ) {
                       dispatch(removeLayer(labelsLayer))
                     }
                   }
                 }
               })
             }

         }}
         >
           <span className="layer-label">
           { child.title }
           </span>
          </a></li>
        )}
      </ul>
      </div>
    )
  } else {
    return (
      <ul></ul>
    )
  }
}
ToggleLegend = connect()(ToggleLegend)

export default ToggleLegend



// WEBPACK FOOTER //
// ./src/containers/ToggleLegend.js